import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
interface NewBadgeProps {
  dimensions?: 'H16' | 'H24';
}
export const NewBadge = t0 => {
  const $ = _c(4);
  const {
    dimensions: t1
  } = t0;
  const dimensions = t1 === undefined ? "H24" : t1;
  let t2;
  if ($[0] !== dimensions) {
    t2 = cn("flex rounded-xxsmall bg-P-550 font-700 text-Gray-white", {
      "min-h-24 px-6 py-2 typo-caption1 !leading-[20px]": dimensions === "H24"
    }, {
      "h-16 px-4 typo-caption2": dimensions === "H16"
    });
    $[0] = dimensions;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <span className={t2}>NEW</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};